<script setup lang="ts">
defineProps<{
  contentTypeOptions: CheckboxOption[]
  legalCategoryOptions: CheckboxOption[]
  authorOptions: CheckboxOption[]
}>()

const filterState = useSearchFilters({ resetPageOnFilterChange: true })
const searchQuery = useRouteQuery<string>('sq', '')

const searchLegalCategory = defineModel('searchLegalCategory', { default: '' })
const searchAuthor = defineModel('searchAuthor', { default: '' })

const disablePeriodFilter = computed(() => !searchQuery.value)
</script>

<template>
  <div class="flex flex-col gap-s w-full max-w-sm">
    <fieldset class="w-full flex flex-col gap-xs pb-s">
      <legend class="text-small font-bold mb-s">
        Innholdstype
      </legend>
      <SearchContentTypeFilter
        class="gap-xs"
        :content-type-options="contentTypeOptions"
        :selected-content-types="filterState.selectedContentTypes.value"
        :toggle-content-type="filterState.toggleContentType"
      />
    </fieldset>

    <div v-if="legalCategoryOptions.length" class="w-full flex flex-col gap-s pb-s max-w-[348px]">
      <span class="text-small font-bold">
        Rettsområde
      </span>
      <FilterFacetList
        v-model:search="searchLegalCategory"
        class="gap-xs"
        label="Rettsområde"
        name="legalCategory"
        expand-noun="rettsområder"
        :options="legalCategoryOptions"
        :selected="filterState.selectedLegalCategories.value"
        :toggle="filterState.toggleLegalCategory"
      />
    </div>

    <div v-if="authorOptions.length" class="w-full flex flex-col gap-s pb-s max-w-[348px]">
      <span class="text-small font-bold">
        Forfattere
      </span>
      <FilterFacetList
        v-model:search="searchAuthor"
        class="gap-xs"
        label="Forfattere"
        name="author"
        expand-noun="forfattere"
        :options="authorOptions"
        :selected="filterState.selectedAuthors.value"
        :toggle="filterState.toggleAuthor"
      />
    </div>
    
    <SearchPeriodFilter
      v-model:start-year="filterState.startYear.value"
      v-model:end-year="filterState.endYear.value"
      class="max-w-[348px]"
      :disabled="disablePeriodFilter"
      @update="filterState.updateYearFilter"
    />
  </div>
</template>
